import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { getBodyMassIndex, isAbsoluteEmpty } from 'ziphy-web-shared/basic/helpers';
import Elements from '../elements/Elements';
import styles from './BlockElement.module.scss';
export const BlockElementFormFieldInline = observer(({ $element }) => {
    var _a;
    const { config, elements, renderType, renderParams, isEmpty } = $element;
    if (renderType === 'plain' && config.hideIfEmpty && isEmpty) {
        return null;
    }
    else if (renderType === 'plain') {
        return (_jsxs("span", Object.assign({ className: classNames(styles.formFieldInline, styles[renderType], renderParams.className) }, { children: [config.title ? config.title + ': ' : null, _jsx(Elements, { "$element": $element })] })));
    }
    return (_jsxs("div", Object.assign({ className: classNames(styles.formFieldInline, styles[renderType], renderParams.className) }, { children: [_jsxs("div", Object.assign({ className: styles.left }, { children: [config.title && _jsx("div", Object.assign({ className: styles.title }, { children: config.title })), config.description && _jsx("div", Object.assign({ className: styles.description }, { children: config.description }))] })), ((_a = elements === null || elements === void 0 ? void 0 : elements.elements) === null || _a === void 0 ? void 0 : _a.length) > 0 && (_jsx("div", Object.assign({ className: styles.right }, { children: _jsx(Elements, { "$element": $element }) })))] })));
});
export const BlockElementBMI = observer(({ $element }) => {
    var _a, _b, _c, _d, _e, _f;
    const { config, renderType, renderParams } = $element;
    if (!config.customData)
        return _jsx(_Fragment, {});
    const { height: heightPath, weight: weightPath } = config.customData;
    let height = (_b = (_a = $element.builder.getFormValueByPath(heightPath)) === null || _a === void 0 ? void 0 : _a.outputValues()) === null || _b === void 0 ? void 0 : _b.value;
    let weight = (_d = (_c = $element.builder.getFormValueByPath(weightPath)) === null || _c === void 0 ? void 0 : _c.outputValues()) === null || _d === void 0 ? void 0 : _d.value;
    if (renderType === 'plain' && height === undefined && weight === undefined) {
        height = (_e = $element.builder.getPayloadValueByPath(heightPath)) === null || _e === void 0 ? void 0 : _e.value;
        weight = (_f = $element.builder.getPayloadValueByPath(weightPath)) === null || _f === void 0 ? void 0 : _f.value;
    }
    const bmi = useMemo(() => {
        if (!isAbsoluteEmpty(height) && !isAbsoluteEmpty(weight)) {
            return getBodyMassIndex(weight, height);
        }
        return;
    }, [height, weight]);
    useEffect(() => {
        $element.SET_IS_EMPTY(isAbsoluteEmpty(height) || isAbsoluteEmpty(weight));
    }, [height, weight]);
    return (_jsx("div", Object.assign({ className: classNames(styles.bmi, styles[renderType], renderParams.className) }, { children: bmi && _jsx("span", Object.assign({ className: renderType === 'plain' ? undefined : styles.badge }, { children: bmi })) })));
});
export const BlockElementInline = observer(({ $element }) => {
    const { renderType, renderParams } = $element;
    return (_jsx("span", Object.assign({ className: classNames(styles.inline, styles[renderType], renderParams.className) }, { children: _jsx(Elements, { "$element": $element }) })));
});
export const BlockElementDefault = observer(({ $element }) => {
    const { renderType, renderParams } = $element;
    return (_jsx("div", Object.assign({ className: classNames(styles.default, styles[renderType], renderParams.className) }, { children: _jsx(Elements, { "$element": $element }) })));
});
